import React, { useEffect, useState } from 'react';
import { withStyles, makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import ArrowRightSharpIcon from '@mui/icons-material/ArrowRight';
import DialogContentText from "@mui/material/DialogContentText";
import {  ListItem, List, Typography} from "@mui/material";
const styles = (theme) => ({
    root: {
        display: "flex",
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    }
});

const useStyles = makeStyles((theme) => ({
    sectiondivider: {
        margin: theme.spacing(1),
    },
}));

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        display: 'flex',
        justifyContent: "left",
        backgroundColor: theme.palette.background.default,
        [theme.breakpoints.down('sm')]: {
            padding: "0.5rem",
        }
    },
    UserDetails: {
        display: 'flex',
    }
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);


export default function EditProfileValidationDialog(props) {
    const classes = useStyles();
    return (
        <Dialog
            open={props.validationDialogOpen}
            onClose={props.onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle>Your profile cannot be submitted. Please return to your profile, complete the following required questions, and save your work before clicking "submit".</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" style={{ color: "text" }}>
                    <List>
                        {props.validationMessageList.map(message => {
                            return <ListItem style={{ alignItems: "self-start" }}>
                                <ArrowRightSharpIcon size="small" fontSize="small" style={{ color: "text", paddingRight: '5px' }} />
                                {" " + message}
                            </ListItem>
                        })}</List>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={props.onClose}
                    color="primary"
                    autoFocus
                >
                    Close
      </Button>
            </DialogActions>
        </Dialog>
    )
}